<template>
  <div class="menuMobile mobile">
    <v-navigation-drawer v-model="open" temporary fixed>
      <template v-slot:prepend>
        <v-list-item two-line>
          <v-list-item-avatar>
            <img
              src="https://slide1-images.s3.us-east-1.amazonaws.com/public/assets/userAsset.jpg"
            />
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ user && user.nome }}</v-list-item-title>
            <v-list-item-subtitle>{{
              user && user.grupo.nome
            }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>

      <v-list nav dense class="mobile">
        <template v-for="(menu, index) in menus">
          <v-list-item
            v-if="menu.isMobile && menu.link && temPermissao(menu)"
            :to="menu.link"
          >
            <v-list-item-title
              style="
                padding: 15px 0;
                display: flex;
                align-items: center;
                column-gap: 10px;
              "
            >
              <v-icon>{{ menu.icon }}</v-icon>
              {{ changeNames(menu.name) }}</v-list-item-title
            >
          </v-list-item>
        </template>
      </v-list>

      <template v-slot:append>
        <v-list-item @click="$emit('logout')">
          <v-list-item-title>
            <v-icon>mdi-logout</v-icon> Sair</v-list-item-title
          >
        </v-list-item>
      </template>
    </v-navigation-drawer>
  </div>
</template>

<script>
import {
  relatorios,
  configs,
  menus,
  gestaoMunicipios,
  cadastros,
} from "./constants";
import { mapGetters } from "vuex";
import { compare } from "../../helpers/orderByAsc";
export default {
  name: "MenuMobile",
  components: {},
  props: {
    drawer: false,
  },
  data() {
    return {
      panel: 0,
      open: false,
      menus: [
        ...relatorios,
        ...configs,
        ...menus,
        ...gestaoMunicipios,
        ...cadastros,
      ].sort((a, b) => compare(a, b, "name")),
      userRelatorios:
        (JSON.parse(localStorage.getItem("user")) &&
          JSON.parse(localStorage.getItem("user")).grupo.relatorioAdm) ||
        [],
    };
  },
  watch: {
    drawer(e) {
      this.open = e;
    },
    open(e) {
      this.$emit("open", e);
    },
  },
  computed: {
    ...mapGetters([
      "isSala",
      "isAT",
      "isParceiro",
      "isFullAdmin",
      "groupsConfig",
      "config",
      "logo",
      "isGov",
      "user",
    ]),
  },

  methods: {
    addUser(link) {
      return link.replace("userId", this.user.usuarioId);
    },
    nextPage(menu) {
      if (!menu.link || this.$route.path.indexOf(menu.link) > -1) return;
      this.$router.push(menu.link);
    },
    habilitarGrupo(grupo) {
      if (!grupo && !grupo.children) return true;
      return grupo.children.some((item) => this.temPermissao(item));
    },
    temPermissao(menu) {
      if (this.isFullAdmin) return true;
      if (menu.config == "isFullAdmin" && this.isFullAdmin) return true;
      if (this.groupsConfig[menu.configPai] && this.config[menu.configPai]) {
        if (this.groupsConfig[menu.config] && this.config[menu.config]) {
          return true;
        }
      } else if (this.groupsConfig[menu.config] && this.config[menu.config]) {
        return true;
      }

      return false;
    },
    changeNames(name) {
      if (this.isGov) {
        name = name.replace("Município", "Projeto");
        return name;
      }

      if (this.isSala) {
        name = name.replace("Município", "Sala");
        return name;
      }

      if (this.isParceiro) {
        name = name.replace("Município", "Parceiro");
        return name;
      }

      if (this.isAT) {
        name = name
          .replace("Meus Encontros", "Minhas Agendas")
          .replace("Encontros", "Agendas");
        return name;
      }

      return name;
    },
  },
  mounted() {},
};
</script>
<style lang="scss">
.menuMobile.mobile {
  overflow: auto;
}
</style>
